import React from 'react'
import { Link, NavLinkProps } from 'react-router-dom'

import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core/styles'
import { FabProps } from '@material-ui/core/Fab'
import AddIcon from '@material-ui/icons/Add'
import { Fab } from '@material-ui/core'

interface Props {
  to: string
}

const styles = (theme: Theme) => createStyles({
  root: {
    position: 'fixed',
    bottom: 3 * theme.spacing(),
    right: 3 * theme.spacing(),
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const PlayButton: React.FC<InjectedProps> = ({ to, classes }) => {
  const component = React.useCallback(
    ({ innerRef, ...buttonProps }: FabProps) => <Link {...buttonProps as NavLinkProps} to={to} />,
    [to],
  )

  return (
    <Fab
      color="primary"
      className={classes.root}
      component={component}
    >
      <AddIcon />
    </Fab>
  )
}

export default withStyles(styles)(PlayButton)
